// // @flow
//
export default (pointsWithAngles) => {
  // Adjacent angles should not have an angular distance of more than Math.PI
  return pointsWithAngles
}
